import { render, staticRenderFns } from "./aftersaleRD.vue?vue&type=template&id=f4a5d546&"
import script from "./aftersaleRD.vue?vue&type=script&lang=ts&"
export * from "./aftersaleRD.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports